module.exports = __webpack_public_path__ + "static/media/hive.49d204fa.jpg";